


































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetTerms } from "@/request/projects";
import { GetOssParams } from "@/request/cdr";
import * as OSS from "ali-oss";
import Jiatingzhuzhi from "./custom-contents/jiatingzhuzhi.vue";
import Zhusu from "./custom-contents/zhusu.vue";
import Xianbingshi from "./custom-contents/xianbingshi.vue";
import Zhongyaoyinpian from "./custom-contents/zhongyaoyinpian.vue";
import Qitayongyao from "./custom-contents/qitayongyao.vue";
import Wenjian from "./custom-contents/wenjian.vue";
import Shipin from "./custom-contents/shipin.vue";
import Jifentiao from "./custom-contents/jifentiao.vue";
import Yatongdian from "./custom-contents/yatongdian.vue";
@Component({
  components: {
    Jiatingzhuzhi,
    Zhusu,
    Xianbingshi,
    Zhongyaoyinpian,
    Qitayongyao,
    Wenjian,
    Shipin,
    Jifentiao,
    Yatongdian,
  },
})
export default class CdrTemplateTransfer extends Vue {
  @Prop()
  private index: any;
  @Prop()
  private content: any;
  private scoreRadioSelected: any = "";
  private resultOptions: any[] = [];
  private ossReady: boolean = false;
  private get ossClient() {
    return this.$store.state.ossClient;
  }
  /**
   * @description 获取store中的可编辑状态
   */
  private get ifCompose() {
    return this.$store.state.cdrIfCompose;
  }
  /**
   * @description content双向绑定
   */
  private contentChange() {
    this.$emit("update:content", this.content);
  }
  @Watch("content.type", { immediate: true })
  private contentTypeChange(type) {
    if (this.content["type"] === "计分单选") {
      this.$nextTick().then(() => {
        if (this.content.value) {
          const name = this.content.value.name;
          this.content.options.map((item: any, index: any) => {
            if (item.name === name) {
              this.scoreRadioSelected = index;
            }
          });
        }
      });
    }
    if (this.content["type"] === "多选") {
      this.$nextTick().then(() => {
        if (!Array.isArray(this.content.value)) {
          this.content.value = [];
        }
      });
    }
    if (this.content["type"] === "压痛点") {
      console.log(this.content);
      if (!this.content.value["L左侧"]) {
        this.$set(this.content.value, "L左侧", {});
      }
      if (!this.content.value["R右侧"]) {
        this.$set(this.content.value, "R右侧", {});
      }
    }
    if (this.content["type"] === "sf36计分单选") {
      this.$nextTick().then(() => {
        if (this.content.value) {
          const name = this.content.value.name;
          this.content.options.map((item: any, index: any) => {
            if (item.name === name) {
              this.scoreRadioSelected = index;
            }
          });
        }
      });
    }
    if (this.content["type"] === "搜索多选") {
      this.$nextTick().then(() => {
        this.resultOptions = this.content.value;
      });
    }
    if (this.content["type"] === "文件") {
      // this.createOss().then(() => {
      //   this.ossReady = true;
      // });
    }
    if (this.content["type"] === "计分条") {
      if (this.content.value === "") {
        this.content.value = 0;
      }
    }
  }
  /**
   * @description 计分单选变化处理
   */
  private scoreRadioChange(value) {
    this.content.value = this.content.options[value];
  }
  /**
   * @description 搜索
   */
  private fetchOptions(ev) {
    let searchType: string = this.content["title"];
    if (searchType === "伴随症状") {
      searchType = "中医症状";
    }
    const params: any = {
      params: {
        type: searchType,
        search: ev,
      },
    };
    GetTerms(this, params).then((data: any) => {
      this.resultOptions = data.concat(this.content.value);
    });
  }
  /**
   * @description 计算是否应该是灰色背景
   */
  private calGrayBack(index) {
    // 3,4,7,8,11,12,15,16,19,20
    index++;
    const t = (index + 1) % 4;
    if (t === 0) {
      return true;
    }
    if (index % 4 === 0) {
      return true;
    }
    return false;
  }
  /**
   * @description 创建oss
   */
  private createOss() {
    return new Promise((resolve, reject) => {
      GetOssParams(this).then((data: any) => {
        const client = new OSS({
          accessKeyId: data.Credentials.AccessKeyId,
          accessKeySecret: data.Credentials.AccessKeySecret,
          stsToken: data.Credentials.SecurityToken,
          endpoint: data.endpoint,
          bucket: data.bucket,
        });
        this.$store.commit("updateOss", client);
        resolve();
      });
    });
  }
  /**
   * @description 多多嵌套点击外层选项
   */
  private clickParent(item) {
    if (!item.value) {
      item.content = "";
      if (item["options"] && item["options"].length > 0) {
        item["options"].forEach((ele) => {
          ele.value = false;
          ele.content = "";
        });
      }
    }
  }
  /**
   * @description 多多嵌套点击里层选项
   */
  private clickChild(child, parent) {
    if (child.value) {
      parent.value = true;
      if (this.content.type === "单多嵌套选择") {
        this.clickRatioParent(parent);
      }
    } else {
      child.content = "";
    }
  }
  /**
   * @description 单多、多多嵌套input值改变
   */
  private inputChange(child, parent) {
    if (child.content) {
      child.value = true;
      if (parent) {
        parent.value = true;
      }
      if (this.content.type === "单多嵌套选择") {
        this.clickRatioParent(child);
      }
    }
  }
  /**
   * @description 单多嵌套点击外层选项
   */
  private clickRatioParent(item) {
    this.content["options"].forEach((element) => {
      if (element.name !== item.name) {
        element.value = false;
        element.content = "";
        if (element["options"] && element["options"].length > 0) {
          element["options"].forEach((ele) => {
            ele.value = false;
            ele.content = "";
          });
        }
      }
    });
  }
}
